const createCommand = async ({ params, api }) => {
  return await api('commands', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createCommand;